<div class="grid bg-white md:grid-cols-2 md:bg-transparent w-full">
    <div class="md:block flex justify-center px-8 pt-8 md:px-20">
        <div class="md:mb-8 md:p-0 flex flex-col justify-center">
            <div class="md:pt-12 md:pb-2">
                <img class="img-responsive rounded-lg" src={{model.thumb}}>
            </div>
            <div class="flex justify-between items-end">
                <div>
                    <p><span class="text-lg font-bold">{{ baseRent | currency : 'USD' : 'symbol' : '1.0-0' }}</span>
                        /mo</p>
                </div>
                <div class="justify-items-end">
                    <p class="text-right"><span class="font-bold">{{model.beds}}</span> bd | <span
                            class="font-boldr">{{model.baths}}</span> ba | <span class="font-bold">{{model.sqft}}</span>
                        sqft</p>
                </div>
            </div>
            <div class="pb-4">
                <div>{{model.title}}</div>
            </div>
        </div>
    </div>
    <div>
        <router-outlet></router-outlet>
    </div>
</div>